
import CloudFun, { Condition, defineComponent, Operator, ref } from "@cloudfun/core";
import Grid, { GridOptions } from "@/cloudfun/components/Grid.vue";
import { VxeFormProps } from "vxe-table";

export default defineComponent({
  components: {
    Grid,
  },
  setup() {
    const model = CloudFun.current?.model;
    const grid = ref<any>({});
    const uploader = ref<any>({});

    var printColumns = [{ field: "Name" }, { field: "Description" }];

    const gridOptions: GridOptions = {
      id: "user",
      title: "片數",
      multiselect: true,
      canCreate: true,
      canDelete: true,
      mode: 'inline',
      toolbarConfig: {
        custom: true,
        refresh: true,
      },
      printConfig: {
        sheetName: "片數清單",
        columns: printColumns,
        modes: ["current", "selected", "all"],
      },
      exportConfig: {
        filename: "片數清單",
        type: "csv",
        types: ["html", "csv"],
        mode: "all",
        modes: ["current", "selected", "all"],
        columns: printColumns,
      },
      columns: [
        {
          field: "TextValue", title: "文字", showHeaderOverflow: true, showOverflow: true, sortable: true,
          filters: [{ checked: false, label: "包含" }], slots: { filter: "filter-name" },
          editRender: { name: '$input', immediate: true, props: { type: 'text' } }
        },
        {
          field: "Value", title: "值", showHeaderOverflow: true, showOverflow: true, sortable: true,
          filters: [{ checked: false, label: "包含" }], slots: { filter: "filter-name" },
          editRender: { name: '$input', immediate: true, props: { type: 'text' } }
        },
        {
          field: "DecimalValue", title: '數值', align: "right", showHeaderOverflow: true, showOverflow: true, sortable: true, width: 130,
          editRender: { name: '$input', immediate: true, props: { type: 'number' } }
        },
      ],
      promises: {
        query: model ? (params) => {
          params.condition = new Condition();
          params.condition.and('AttributeId', Operator.Equal, 1);
          if (!params.sortings || params.sortings.length === 0) {
            params.sortings = [{ column: 'DecimalValue', order: 0 }]; // 0 = ascending
          }
          return model.dispatch("attributeValues/query", params)
        } : undefined,
        queryAll: model ? () => model.dispatch("attributeValues/query") : undefined,
        save: model ? (params) => model.dispatch("attributeValues/save", params) : undefined,
      },
      modalConfig: { width: 600, showFooter: true },
    };

    const formOptions: VxeFormProps = {
      titleWidth: 80,
      titleAlign: "right",
      span: 3,
      items: [
        { field: "TextValue", title: "文字", span: 24, itemRender: { name: "$input", props: { placeholder: "請輸入名稱" } } },
        { field: "Value", title: "值", span: 24, itemRender: { name: "$input", props: { placeholder: "請輸入名稱" } } },
        { field: "DecimalValue", title: "數值", span: 24, itemRender: { name: "$input", props: { type: "number", placeholder: "請輸入數值" } } },
        { field: "DecimalValue", title: "數值123", span: 24, itemRender: { name: "$input", props: { visible: false, placeholder: "請輸入數值" } } }
      ],
      rules: {
        TextValue: [{ required: true }],
        Value: [{ required: true }],
        DecimalValue: [{ required: true }],
      }
    };
    return {
      grid,
      uploader,
      gridOptions,
      formOptions,
    };
  },
  methods: {
    hideBatchDropDown () {
      cash("#batch-dropdown").dropdown("hide");
    }
  }
});
